export const tranTypeList = [
  { value: 'Z', label: 'Z - Payment' },
  { value: 'Y', label: 'Y - Receipt' },
  { value: 'A', label: 'A - Adjustment Debit Note' },
  { value: 'M', label: 'M - Direct Business Debit Note' },
  { value: 'N', label: 'N - Coinsurance Outward Debit Note' },
  { value: 'O', label: 'O - Reinsurance Inward Debit Note' },
  { value: 'P', label: 'P - Reinsurance Outward Debit Note' },
  { value: 'Q', label: 'Q - Miscellaneous Debit Note' },
  { value: 'W', label: 'W - Claims Debit Note' },
  { value: 'B', label: 'B - Adjustment Credit Note' },
  { value: 'R', label: 'R - Direct Business Credit Note' },
  { value: 'S', label: 'S - Coinsurance Outward Credit Note' },
  { value: 'T', label: 'T - Reinsurance Inward Credit Note' },
  { value: 'U', label: 'U - Reinsurance Outward Credit Note' },
  { value: 'V', label: 'V - Miscellaneous Credit Note' },
  { value: 'X', label: 'X - Claims Credit Note' }
]

export const branchOption = [
  { value: 'A', label: 'All' },
  { value: 'S', label: 'Selected' }
]
